import axios from "./../../config/axios";

function upload(data, onUploadProgress) {
    return axios().post(
        "/item-image/upload",
        data,
        {
            headers: {
                'content-type': 'multipart/form-data'
            },
            onUploadProgress
        }
    )
}

export default {
    upload
}